interface FrameState {
  isHikeEdit: boolean;
  originalHikeId: number | null;
  routes: Record<string, any>;
}

function allRoutesFeatureCollection(routes: Record<string, any>) {
  const features: any[] = [];

  Object.values(routes).forEach((route: any) => {
    (route.markers || []).forEach((marker: any) => features.push(marker.toGeoJson()));
    (route.lineStrings || []).forEach((lineString: any) => features.push(lineString.toGeoJson()));
  });

  return { type: 'FeatureCollection' as const, features };
}

/**
 * What the planner frames when it opens, as setMapBounds arguments, or null when there is nothing
 * to frame. An existing hike, being edited or copied, is framed whole: every route's markers and
 * lines. Anything else frames the active route's markers.
 */
export function routesToFrame(state: FrameState, activeRouteMarkers: { features: any[] }) {
  const wholeHike = state.isHikeEdit || state.originalHikeId != null;

  if (wholeHike && Object.keys(state.routes).length > 0) {
    const geoJson = allRoutesFeatureCollection(state.routes);
    return geoJson.features.length > 0 ? { geoJson, duration: 1000 } : null;
  }

  return activeRouteMarkers.features.length > 0 ? { geoJson: activeRouteMarkers } : null;
}
